import classNames from 'classnames';
import { loaderVariants } from './variants';
import { LoaderVariants } from './types';
import { ComponentRegistry } from 'runtime/registry/components/ComponentRegistry';
import './loader.scss';

interface Props {
  type?: string;
  text?: string;
  isInternal?: boolean;
  customClass?: string;
  variant?: LoaderVariants;
}

export default function Loader({
  type,
  text,
  isInternal,
  customClass = '',
  variant = 'default',
}: Props) {
  const config = ComponentRegistry.getConfig('Loader');

  const currentVariant = config?.props?.variant ?? variant ?? 'default';

  const SvgComponent = loaderVariants[currentVariant] ?? loaderVariants.default;

  return (
    <div
      className={classNames(
        'ui-loader',
        {
          [`ui-loader_${type}`]: true,
          'ui-loader_internal': isInternal,
          'ui-loader_whole-screen': !isInternal,
        },
        customClass
      )}>
      {SvgComponent && <SvgComponent />}

      {text && <span className='ui-loader__text'>{text}</span>}
    </div>
  );
}
